import { useQueryClient } from '@tanstack/react-query';
import { useEntityForm } from '@/shared/lib/useEntityForm';
import { ErrorList } from '@/shared/ui/ErrorList';
import { ModalDialog } from '@/shared/ui/ModalDialog';
import { TextField } from '@/shared/ui/TextField';
import { emptyGeneratePromocodes, generatePromocodes, type GeneratePromocodesValues } from './promoSectionsApi';

type Props = {
  promoId: number;
  onClose: () => void;
};

export const PromocodeGenerateModal = ({ promoId, onClose }: Props) => {
  const qc = useQueryClient();
  const { values, errors, setField, save, isSaving } = useEntityForm(
    emptyGeneratePromocodes(),
    (v: GeneratePromocodesValues) => generatePromocodes(promoId, v),
    () => {
      void qc.invalidateQueries({ queryKey: ['promocodes', promoId] });
      onClose();
    },
  );

  return (
    <ModalDialog title="Сгенерировать промокод" onClose={onClose} onSave={save} isSaving={isSaving}>
      <TextField
        label="Сумма промокода *"
        type="number"
        value={values.amount}
        errors={errors.amount}
        onChange={(v) => setField('amount', v)}
      />
      <TextField
        label="Количество *"
        type="number"
        value={values.count}
        errors={errors.count}
        onChange={(v) => setField('count', v)}
      />
      <TextField label="Валюта *" value="RUB" readOnly onChange={() => undefined} />
      <TextField
        label="Дата истечения *"
        type="datetime-local"
        value={values.expiredTime}
        errors={errors.expired_time}
        onChange={(v) => setField('expiredTime', v, 'expired_time')}
      />
      <ErrorList errors={{ common: errors.common ?? [], server: errors.server ?? [] }} />
      <p className="text-muted">Генерация промокода может занять до 5 минут.</p>
    </ModalDialog>
  );
};
